"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpeech = void 0;
var _react = require("react");
const useSpeech = () => {
  const synth = (0, _react.useRef)(window.speechSynthesis);
  const [isSpeaking, setIsSpeaking] = (0, _react.useState)(false);
  const [currentText, setCurrentText] = (0, _react.useState)(null);
  const speak = (0, _react.useCallback)(text => {
    if (synth.current.speaking) {
      setIsSpeaking(false);
      setCurrentText(null);
      synth.current.cancel();
    }
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.onstart = () => {
      setIsSpeaking(true);
      setCurrentText(text);
    };
    utterance.onend = () => {
      setIsSpeaking(false);
      setCurrentText(null);
    };
    synth.current.speak(utterance);
  }, []);
  const stop = (0, _react.useCallback)(() => {
    synth.current.cancel();
    setIsSpeaking(false);
    setCurrentText(null);
  }, []);
  return {
    isSpeaking,
    currentText,
    speak,
    stop
  };
};
exports.useSpeech = useSpeech;